module.exports = __webpack_public_path__ + "__static/site-1783523783704/img/crocodile-mobile-english.e1babb5d.jpg";